import * as Dtos from "../dtos/Tmd.dtos";
import { IFormFilter } from "../reducers/index";

export const
    LoadTrialGroupContractByTrialGroupId: ITrialGroupContractLoadByTrialGroupIdActionCreator = (trialGroupId) => {
        return {
            type: ACTION_TRIALGROUPCONTRACT_LOAD_BY_TRIAL_GROUP_ID,
            trialGroupId
        }
    },
    LoadTrialGroupContractById: ITrialGroupContractLoadByIdActionCreator = (id) => {
        return {
            type: ACTION_TRIALGROUPCONTRACT_LOAD_BY_ID,
            id
        }
    },
    LoadSuccess: ITrialGroupContractLoadSuccessActionCreator = (formData, formState, formProperties, lookups, responseStatus) => {
        return {
            type: ACTION_TRIALGROUPCONTRACT_LOAD_SUCCESS,
            formData,
            formState,
            formProperties,
            lookups,
            responseStatus
        }
    },
    LoadFailure: ITrialGroupContractLoadFailureActionCreator = (responseStatus) => {
        return {
            type: ACTION_TRIALGROUPCONTRACT_LOAD_FAILURE,
            responseStatus
        }
    },

    SaveTrialGroupContract: ITrialGroupContractSaveActionCreator = (formData) => {
        return {
            type: ACTION_TRIALGROUPCONTRACT_SAVE,
            formData
        }
    },
    SaveSuccess: ITrialGroupContractSaveSuccessActionCreator = (formData, formState, responseStatus) => {
        return {
            type: ACTION_TRIALGROUPCONTRACT_SAVE_SUCCESS,
            formData,
            formState,
            responseStatus
        }
    },
    SaveFailure: ITrialGroupContractSaveFailureActionCreator = (responseStatus) => {
        return {
            type: ACTION_TRIALGROUPCONTRACT_SAVE_FAILURE,
            responseStatus
        }
    },

    ValidateTrialGroupContract: ITrialGroupContractValidateActionCreator = (formData) => {
        return {
            type: ACTION_TRIALGROUPCONTRACT_VALIDATE,
            formData
        }
    },
    ValidateSuccess: ITrialGroupContractValidateSuccessActionCreator = (formData, formState, responseStatus) => {
        return {
            type: ACTION_TRIALGROUPCONTRACT_VALIDATE_SUCCESS,
            formData,
            formState,
            responseStatus
        }
    },
    ValidateFailure: ITrialGroupContractValidateFailureActionCreator = (responseStatus) => {
        return {
            type: ACTION_TRIALGROUPCONTRACT_VALIDATE_FAILURE,
            responseStatus
        }
    },

    CreateTrialGroupContract: ITrialGroupContractCreateActionCreator = (trialGroupId) => {

        return {
            type: ACTION_TRIALGROUPCONTRACT_CREATE,
            trialGroupId
        }
    },
    CreateSuccess: ITrialGroupContractCreateSuccessActionCreator = (formData, formState, formProperties, lookups) => {
        return {
            type: ACTION_TRIALGROUPCONTRACT_CREATE_SUCCESS,
            formData,
            formState,
            formProperties,
            lookups
        }
    },
    CreateFailure: ITrialGroupContractCreateFailureActionCreator = (responseStatus) => {
        return {
            type: ACTION_TRIALGROUPCONTRACT_CREATE_FAILURE,
            responseStatus
        }
    },

    DeleteTrialGroupContract: ITrialGroupContractDeleteActionCreator = (id) => {
    
        return {
            type: ACTION_TRIALGROUPCONTRACT_DELETE,
            id
        }
    },
    DeleteSuccess: ITrialGroupContractDeleteSuccessActionCreator = () => {
        return {
            type: ACTION_TRIALGROUPCONTRACT_DELETE_SUCCESS
        }
    },
    DeleteFailure: ITrialGroupContractDeleteFailureActionCreator = (responseStatus) => {
        return {
            type: ACTION_TRIALGROUPCONTRACT_DELETE_FAILURE,
            responseStatus
        }
    },

    Clear: ITrialGroupContractClearActionCreator = (propertiesToClear?) => {
        return {
            type: ACTION_TRIALGROUPCONTRACT_CLEAR,
            propertiesToClear
        }
    },

    Filter: ITrialGroupContractFilterActionCreator = (formFilter) => {
        return {
            type: ACTION_TRIALGROUPCONTRACT_FILTER,
            formFilter
        }
    };



export const
    ACTION_TRIALGROUPCONTRACT_LOAD_BY_TRIAL_GROUP_ID = "ACTION_TRIALGROUPCONTRACT_LOAD_BY_TRIAL_GROUP_ID",
    ACTION_TRIALGROUPCONTRACT_LOAD_BY_ID = "ACTION_TRIALGROUPCONTRACT_LOAD_BY_ID",
    ACTION_TRIALGROUPCONTRACT_LOAD_SUCCESS = "ACTION_TRIALGROUPCONTRACT_LOAD_SUCCESS",
    ACTION_TRIALGROUPCONTRACT_LOAD_FAILURE = "ACTION_TRIALGROUPCONTRACT_LOAD_FAILURE",

    ACTION_TRIALGROUPCONTRACT_SAVE = "ACTION_TRIALGROUPCONTRACT_SAVE",
    ACTION_TRIALGROUPCONTRACT_SAVE_SUCCESS = "ACTION_TRIALGROUPCONTRACT_SAVE_SUCCESS",
    ACTION_TRIALGROUPCONTRACT_SAVE_FAILURE = "ACTION_TRIALGROUPCONTRACT_SAVE_FAILURE",

    ACTION_TRIALGROUPCONTRACT_VALIDATE = "ACTION_TRIALGROUPCONTRACT_VALIDATE",
    ACTION_TRIALGROUPCONTRACT_VALIDATE_SUCCESS = "ACTION_TRIALGROUPCONTRACT_VALIDATE_SUCCESS",
    ACTION_TRIALGROUPCONTRACT_VALIDATE_FAILURE = "ACTION_TRIALGROUPCONTRACT_VALIDATE_FAILURE",

    ACTION_TRIALGROUPCONTRACT_CREATE = "ACTION_TRIALGROUPCONTRACT_CREATE",
    ACTION_TRIALGROUPCONTRACT_CREATE_SUCCESS = "ACTION_TRIALGROUPCONTRACT_CREATE_SUCCESS",
    ACTION_TRIALGROUPCONTRACT_CREATE_FAILURE = "ACTION_TRIALGROUPCONTRACT_CREATE_FAILURE",

    ACTION_TRIALGROUPCONTRACT_DELETE = "ACTION_TRIALGROUPCONTRACT_DELETE",
    ACTION_TRIALGROUPCONTRACT_DELETE_SUCCESS = "ACTION_TRIALGROUPCONTRACT_DELETE_SUCCESS",
    ACTION_TRIALGROUPCONTRACT_DELETE_FAILURE = "ACTION_TRIALGROUPCONTRACT_DELETE_FAILURE",

    ACTION_TRIALGROUPCONTRACT_CLEAR = "ACTION_TRIALGROUPCONTRACT_CLEAR",

    ACTION_TRIALGROUPCONTRACT_FILTER = "ACTION_TRIALGROUPCONTRACT_FILTER";

export interface ITrialGroupContractLoadByTrialGroupIdAction {
    type: "ACTION_TRIALGROUPCONTRACT_LOAD_BY_TRIAL_GROUP_ID";
    trialGroupId: number;
}

export interface ITrialGroupContractLoadByTrialGroupIdActionCreator {
    (trialGroupId: number): ITrialGroupContractLoadByTrialGroupIdAction;
}

export interface ITrialGroupContractLoadSuccessAction {
    type: "ACTION_TRIALGROUPCONTRACT_LOAD_SUCCESS";
    formData: Dtos.TrialGroupContract | Dtos.TrialGroupContract[];
    formState: Dtos.FormState;
    formProperties: Dtos.FormProperty[];
    lookups: Dtos.Lookup[];
    responseStatus: Dtos.ResponseStatus;
}

export interface ITrialGroupContractLoadSuccessActionCreator {
    (
        formData: Dtos.TrialGroupContract | Dtos.TrialGroupContract[],
        formState: Dtos.FormState,
        formProperties: Dtos.FormProperty[],
        lookups: Dtos.Lookup[],
        responseStatus: Dtos.ResponseStatus
    ): ITrialGroupContractLoadSuccessAction;
}

export interface ITrialGroupContractLoadFailureAction {
    type: "ACTION_TRIALGROUPCONTRACT_LOAD_FAILURE";
    responseStatus: Dtos.ResponseStatus;
}

export interface ITrialGroupContractLoadFailureActionCreator {
    (responseStatus: Dtos.ResponseStatus): ITrialGroupContractLoadFailureAction;
}

export interface ITrialGroupContractLoadByIdAction {
    type: "ACTION_TRIALGROUPCONTRACT_LOAD_BY_ID";
    id: number;
}

export interface ITrialGroupContractLoadByIdActionCreator {
    (id: number): ITrialGroupContractLoadByIdAction;
}

export interface ITrialGroupContractSaveAction {
    type: "ACTION_TRIALGROUPCONTRACT_SAVE";
    formData: Dtos.TrialGroupContract;

}

export interface ITrialGroupContractSaveActionCreator {
    (
        formData: Dtos.TrialGroupContract
    ): ITrialGroupContractSaveAction;
}

export interface ITrialGroupContractSaveSuccessAction {
    type: "ACTION_TRIALGROUPCONTRACT_SAVE_SUCCESS";
    formData: Dtos.TrialGroupContract;
    formState: Dtos.FormState,
    responseStatus: Dtos.ResponseStatus;
}

export interface ITrialGroupContractSaveSuccessActionCreator {
    (
        formData: Dtos.TrialGroupContract,
        formState: Dtos.FormState,
        responseStatus: Dtos.ResponseStatus
    ): ITrialGroupContractSaveSuccessAction;
}

export interface ITrialGroupContractSaveFailureAction {
    type: "ACTION_TRIALGROUPCONTRACT_SAVE_FAILURE";
    responseStatus: Dtos.ResponseStatus
}

export interface ITrialGroupContractSaveFailureActionCreator {
    (responseStatus: Dtos.ResponseStatus): ITrialGroupContractSaveFailureAction;
}

export interface ITrialGroupContractValidateAction {
    type: "ACTION_TRIALGROUPCONTRACT_VALIDATE";
    formData: Dtos.TrialGroupContract;

}

export interface ITrialGroupContractValidateActionCreator {
    (
        formData: Dtos.TrialGroupContract
    ): ITrialGroupContractValidateAction;
}

export interface ITrialGroupContractValidateSuccessAction {
    type: "ACTION_TRIALGROUPCONTRACT_VALIDATE_SUCCESS";
    formData: Dtos.TrialGroupContract;
    formState: Dtos.FormState,
    responseStatus: Dtos.ResponseStatus;
}

export interface ITrialGroupContractValidateSuccessActionCreator {
    (
        formData: Dtos.TrialGroupContract,
        formState: Dtos.FormState,
        responseStatus: Dtos.ResponseStatus
    ): ITrialGroupContractValidateSuccessAction;
}

export interface ITrialGroupContractValidateFailureAction {
    type: "ACTION_TRIALGROUPCONTRACT_VALIDATE_FAILURE";
    responseStatus: Dtos.ResponseStatus
}

export interface ITrialGroupContractValidateFailureActionCreator {
    (responseStatus: Dtos.ResponseStatus): ITrialGroupContractValidateFailureAction;
}

export interface ITrialGroupContractCreateAction {
    type: "ACTION_TRIALGROUPCONTRACT_CREATE",
    trialGroupId: number
}

export interface ITrialGroupContractCreateActionCreator {
    (trialGroupId: number): ITrialGroupContractCreateAction
}

export interface ITrialGroupContractCreateSuccessAction {
    type: "ACTION_TRIALGROUPCONTRACT_CREATE_SUCCESS";
    formData: Dtos.TrialGroupContract;
    formState: Dtos.FormState;
    formProperties: Dtos.FormProperty[];
    lookups: Dtos.Lookup[];
}

export interface ITrialGroupContractCreateSuccessActionCreator {
    (
        formData: Dtos.TrialGroupContract,
        formState: Dtos.FormState,
        formProperties: Dtos.FormProperty[],
        lookups: Dtos.Lookup[]
    ): ITrialGroupContractCreateSuccessAction;
}

export interface ITrialGroupContractCreateFailureAction {
    type: "ACTION_TRIALGROUPCONTRACT_CREATE_FAILURE";
    responseStatus: Dtos.ResponseStatus
}

export interface ITrialGroupContractCreateFailureActionCreator {
    (responseStatus: Dtos.ResponseStatus): ITrialGroupContractCreateFailureAction;
}

export interface ITrialGroupContractDeleteAction {
    type: "ACTION_TRIALGROUPCONTRACT_DELETE";
    id: number;
}

export interface ITrialGroupContractDeleteActionCreator {
    (id: number): ITrialGroupContractDeleteAction
}

export interface ITrialGroupContractDeleteSuccessAction {
    type: "ACTION_TRIALGROUPCONTRACT_DELETE_SUCCESS";
}

export interface ITrialGroupContractDeleteSuccessActionCreator {
    (): ITrialGroupContractDeleteSuccessAction;
}

export interface ITrialGroupContractDeleteFailureAction {
    type: "ACTION_TRIALGROUPCONTRACT_DELETE_FAILURE";
    responseStatus: Dtos.ResponseStatus
}

export interface ITrialGroupContractDeleteFailureActionCreator {
    (responseStatus: Dtos.ResponseStatus): ITrialGroupContractDeleteFailureAction;
}

export interface ITrialGroupContractClearAction {
    type: "ACTION_TRIALGROUPCONTRACT_CLEAR";
    propertiesToClear?: string[];
}

export interface ITrialGroupContractClearActionCreator {
    (propertiesToClear?: string[]): ITrialGroupContractClearAction;
}

export interface ITrialGroupContractFilterActionCreator {
    (formFilter: IFormFilter): ITrialGroupContractFilterAction;
}

export interface ITrialGroupContractFilterAction {
    type: "ACTION_TRIALGROUPCONTRACT_FILTER";
    formFilter: IFormFilter;
}

export type TrialGroupContractAction =
    ITrialGroupContractLoadByTrialGroupIdAction |
    ITrialGroupContractLoadByIdAction |
    ITrialGroupContractLoadFailureAction |
    ITrialGroupContractLoadSuccessAction |
    ITrialGroupContractSaveAction |
    ITrialGroupContractSaveSuccessAction |
    ITrialGroupContractSaveFailureAction |
    ITrialGroupContractValidateAction |
    ITrialGroupContractValidateSuccessAction |
    ITrialGroupContractValidateFailureAction |
    ITrialGroupContractCreateAction |
    ITrialGroupContractCreateSuccessAction |
    ITrialGroupContractCreateFailureAction |
    ITrialGroupContractDeleteAction |
    ITrialGroupContractDeleteSuccessAction |
    ITrialGroupContractDeleteFailureAction |
    ITrialGroupContractClearAction | 
    ITrialGroupContractFilterAction;
